import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisableControlDirective } from './disableControl.directive';
import { InputCurrencyDirective } from "./inputCurrency.directive";
import { FeatureFlagDirective } from "./feature-flag.directive";

@NgModule({
  declarations: [DisableControlDirective,
    InputCurrencyDirective,
    FeatureFlagDirective
  ],
  imports: [CommonModule],
  exports: [DisableControlDirective, InputCurrencyDirective, FeatureFlagDirective],
})
export class DirectiveModule { }
